export class DialogSize {
  width = window.innerWidth*(1/4);
  height = window.innerHeight*(3/5);
}